import { render, staticRenderFns } from "./EventBlockDialog.vue?vue&type=template&id=aee77dc2&"
import script from "./EventBlockDialog.vue?vue&type=script&lang=js&"
export * from "./EventBlockDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports